import ApisService from './index'
import { IRoleGroup } from '../interfaces/roleGroupInterfaces'
import { handleError } from '../utils/commonUtils'
import * as queryString from 'query-string'

export function createRoleGroup(data: IRoleGroup) {
  try {
    return ApisService.post('/nhomquyen/create-nhomquyen', data)
  } catch (err) {
    handleError(err)
    throw err
  }
}

export function updateRoleGroup(data: IRoleGroup) {
  try {
    return ApisService.put('/nhomquyen/' + data.id + '/update-nhomquyen', data)
  } catch (err) {
    handleError(err)
    throw err
  }
}

export function getDetailRoleGroup(id: string) {
  try {
    return ApisService.get('/nhomquyen/' + id + '/get-chitiet-nhomquyen')
  } catch (err) {
    handleError(err)
    throw err
  }
}


export function getListRoleGroup(querySt?: string) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return ApisService.get('/nhomquyen/filter-nhomquyen', {
      params: query || {},
    })
  } catch (err) {
    handleError(err)
    throw err
  }
}

export function getListOptionRoleGroup(querySt?: string) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return ApisService.get('/nhomquyen/filter-nhomquyen', {
      params: query || {},
    })
  } catch (err) {
    handleError(err)
    throw err
  }
}


export function deleteRoleGroup(id: string) {
  try {
    return ApisService.delete('/nhomquyen/' + id + '/delete-nhomquyen')
  } catch (err) {
    handleError(err)
    throw err
  }
}

export function deleteMultiRoleGroup(idArr: Array<string>) {
  try {
    return ApisService.delete('/nhomquyen/bulk-delete-nhomquyen', { data: idArr })
  } catch (err) {
    handleError(err)
    throw err
  }
}

/** Gắn / gỡ chức năng vào nhiều nhóm quyền cùng lúc (rebuild quyền có thể lâu). */
export function bulkGanChucNang(data: {
  chucNangIds: number[]
  nhomQuyenIds: number[]
  mode: 'add' | 'remove'
}) {
  try {
    return ApisService.post('/nhomquyen/bulk-gan-chucnang', data, {
      // Nhiều nhóm × nhiều user×CN → rebuild có thể > 60s mặc định.
      timeout: 10 * 60 * 1000,
    })
  } catch (err) {
    handleError(err)
    throw err
  }
}
